import LanguageContext from './LanguageContext';
import { useContext } from 'react';

function useBlogLanguage() {
  const context = useContext(LanguageContext);
  return context.blogText;
}

export default useBlogLanguage;
